<script>
import _ from 'lodash';
import { getAccountLogo, isEligibleForFirstTimeOffer } from "../../utils/helpers";
import PromoBanner from './PromoBanner.vue';
import StarterPromoCard from './StarterPromoCard.vue';
import GoogleReviewPromoCard from './GoogleReviewPromoCard.vue';
import { PLAN_SKU_TYPES, ROUTES } from '../../utils/constants';

const { FREE_PLAN, SUSPENDED_PLAN, TRIAL_PLAN } = PLAN_SKU_TYPES

export default {
  components: {
    PromoBanner,
    StarterPromoCard,
    GoogleReviewPromoCard
  },
  props: ['updatedAccountLogo', 'premiumGateEnabled'],
  name: "navigation",
  data() {
    return {
      user: this.$A.Auth,
      loadingData: false,
      alertMessage: "",
      alertType: "success",
      alertPromise: null,
      renderComponent: true,
      menuitems: [
        { id: 1, name: "Overview", link: "/overview", aliases: ["/dashboard"] },
        { id: 2, name: "Contacts", link: "/contact-archive" },
        { id: 5, name: "Jobs", link: "/jobs" },
        { id: 6, name: "Proofs", link: "/proof-list", aliases: ["/proof-archive"] },
      ],
      moreMenuItems: [
        { id: 3, name: "Workflows", link: "/workflows" },
        { id: 8, name: "Email Templates", link: "/email-templates" },
        { id: 9, name: "Checklists", link: "/checklists" },
        { id: 7, name: "Artwork Intake Forms", link: "/artwork-intake" },
        { id: 10, name: "Files", link: "/files" },
        { id: 4, name: "Preflights", link: "/preflights" },
      ],
      recentActivity: [
        {
          id: 1,
          name: "Proof #1234 was marked not approved by Cody Miles",
          link: "/proof-item",
        },
        {
          id: 2,
          name: "Amy Miles left comments on Proof #4948",
          link: "/proof-item",
        },
        {
          id: 3,
          name: "Proof #1594 missed its deadline",
          link: "/proof-item",
        },
        {
          id: 4,
          name: "Proof #2339 was marked approved by Daniel Noel",
          link: "/proof-item",
        },
        {
          id: 5,
          name: "Proof #2339 was marked approved with changes by Abby Nash",
          link: "/proof-item",
        },
      ],
      isBannerVisible: false
    };
  },
  methods: {
    LogOut() {
      this.$A.LogOut(true);
    },
    ForceUpdateView() {
      this.renderComponent = false;
      this.$nextTick(() => {
        this.renderComponent = true;
      });
    },
    get(object, path, defaultValue) {
      return _.get(object, path, defaultValue);
    },
    updateBannerVisiblity(showBanner) {
      this.isBannerVisible = showBanner;
    }
  },
  computed: {
    activeItem: function () {
      const path = _.get(window, 'location.pathname', '');
      const matchedItem = this.menuitems.find(mi =>
        path.includes(mi.link) || (mi.aliases || []).some(a => path.includes(a))
      );
      return matchedItem ? matchedItem.id : 0;
    },
    isMoreActive: function () {
      const path = _.get(window, 'location.pathname', '');
      return this.moreMenuItems.some(mi => path.includes(mi.link));
    },
    activeMoreItemId: function () {
      const path = _.get(window, 'location.pathname', '');
      const matched = this.moreMenuItems.find(mi => path.includes(mi.link));
      return matched ? matched.id : 0;
    },
    marginClass: function() {
      return this.isBannerVisible ? 'mb-50' : 'mb-0';
    },
    shouldShowDivider: function () {
      return (
        _.get(this.user, 'permissions.role.roleId') === 3 ||
        this.$A.AdminImpersonating !== null
      );
    },
    shouldShowCaptainsDeck: function () {
      return _.get(this.user, 'permissions.role.roleId') === 3;
    },
    curAccount: function () {
      return _.get(this.$A, 'Auth.account', {});
    },
    accountLogo: function () {
      const value = this.updatedAccountLogo || getAccountLogo();
      // Relative `img/...` paths resolve against the current URL. On nested
      // routes (e.g. /artwork-intake/settings, /job-details/:id) that 404s,
      // so absolutize when the path has multiple segments.
      const path = window.location.pathname || '';
      const isNested = path.split('/').filter(Boolean).length > 1;
      if (value.startsWith('img/') && isNested) {
        return window.location.origin + '/' + value;
      }
      return value;
    },
    isFreeUser() {
      const currentUserPlan = _.get(this, '$A.Auth.account.subscription.planSku', FREE_PLAN);
      return currentUserPlan === FREE_PLAN || currentUserPlan === SUSPENDED_PLAN || currentUserPlan === TRIAL_PLAN;
    },
    visibleMenuItems() {
      return this.menuitems;
    },
    shouldShowPromoBanner() {
      return isEligibleForFirstTimeOffer(this.$A.Auth, this.isFreeUser);
    },
  },
  mounted() {
    let self = this;
    this.$root.$on("alert::user", (message, type, timeout) => {
      if (timeout === undefined) {
        timeout = 15000;
      }

      self.alertType = type;

      if (self.alertPromise !== null) {
        self.alertMessage += "<br/>" + message;
      } else {
        self.alertMessage = message;
      }

      clearTimeout(self.alertPromise);
      self.alertPromise = setTimeout(function () {
        self.alertMessage = "";
        self.alertType = "success";
        self.alertPromise = null;
      }, timeout);
    });
    this.$root.$on("api::working", () => {
      self.loadingData = true;
    });
    this.$root.$on("api::idle", () => {
      self.loadingData = false;
    });
    this.$root.$on("nav::reload", () => {
      self.ForceUpdateView();
    });
    if (document.getElementById("hubspot-messages-iframe-container") === null) {
      if (document.getElementById("nav_support") !== null) {
        let a = document.getElementById("nav_support");
        a.parentElement.removeChild(a);
      }
      if (_.get(this.curAccount, 'subscriptionState.sku', []).indexOf('enterprise-code-stacking-1') === -1) {
        let hubSpot = document.createElement("script");
        hubSpot.setAttribute("src", "https://js.hs-scripts.com/4439126.js");
        hubSpot.setAttribute("id", "nav_support");
        document.head.appendChild(hubSpot);
      }
    }
  },
  beforeCreate() {
  },
  beforeDestroy() {
    if (document.getElementById("hubspot-messages-iframe-container") !== null) {
      let a = document.getElementById("hubspot-messages-iframe-container");
      a.parentElement.removeChild(a);
    }
    if (document.getElementById("nav_support") !== null) {
      let a = document.getElementById("nav_support");
      a.parentElement.removeChild(a);
    }
  },
};
</script>

<template>
  <div :class="marginClass">
    <PromoBanner ref="propBanner" @banner-visbility="updateBannerVisiblity" :premium-gate-enabled="premiumGateEnabled"/>
    <div class="fixed-navbar" :class="[isBannerVisible ? 'top-50' : 'top-0', { 'premium-gated': premiumGateEnabled }]">
      <nav class="navbar navbar-expand-lg navbar-light ashore-nav">
        <div class="container-fluid container-navigation" :class="[{ 'premium-gated': premiumGateEnabled }]">
          <a href="/overview" class="ashore-logo" id="overview-tour-step-0"
            :style="`background-image: url(${accountLogo}) !important;`"></a>
          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse am-navbar-collapse" id="navbarNavDropdown">
            <ul class="am-nav-list">
              <li
                v-for="item in visibleMenuItems"
                :key="item.id"
                class="am-nav-item"
                :data-cy="item.name"
              >
                <a
                  :href="item.link"
                  class="am-nav-link"
                  :class="{ 'is-active': activeItem === item.id }"
                  :id="'nav_' + item.name.toLowerCase()"
                >
                  {{ item.name }}
                </a>
              </li>

              <li class="am-nav-item am-dropdown dropdown" data-cy="More">
                <a
                  class="am-nav-link am-dropdown-toggle dropdown-toggle"
                  :class="{ 'is-active': isMoreActive }"
                  href="#"
                  id="nav_more"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  @click.prevent
                >
                  More
                  <svg class="am-chevron" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </a>
                <div class="am-menu dropdown-menu" aria-labelledby="nav_more">
                  <a
                    v-for="item in moreMenuItems"
                    :key="item.id"
                    :href="item.link"
                    class="am-menu-item"
                    :class="{ 'is-active': activeMoreItemId === item.id }"
                    :id="'nav_' + item.name.toLowerCase().replace(/\s+/g, '_')"
                    :data-cy="item.name"
                  >
                    {{ item.name }}
                  </a>
                </div>
              </li>
            </ul>

            <div class="am-nav-right">
              <b-spinner type="grow" label="Spinning" class="loading_data_spinner"
                v-show="loadingData == true"></b-spinner>
              <a data-cy="createProofNavLink" href="/create-proof" id="overview-tour-step-1" class="am-create-btn">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <line x1="12" y1="5" x2="12" y2="19" />
                  <line x1="5" y1="12" x2="19" y2="12" />
                </svg>
                Create Proof
              </a>

              <div class="am-dropdown am-profile dropdown">
                <a
                  class="am-profile-trigger dropdown-toggle"
                  href="#"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  @click.prevent
                >
                  <span
                    class="am-avatar"
                    :style="$A.Auth && $A.Auth.profileImageUrl ? `background-image: url(${$A.Auth.profileImageUrl})` : ''"
                  >
                    <span v-if="!($A.Auth && $A.Auth.profileImageUrl) && curAccount && curAccount.name">
                      {{ curAccount.name.charAt(0) }}
                    </span>
                  </span>
                  <span v-if="curAccount" class="am-profile-name">{{ curAccount.name }}</span>
                  <svg class="am-chevron" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </a>
                <div class="am-menu am-menu-right dropdown-menu dropdown-menu-right" id="account_profile_dropdown">
                  <a href="/profile" class="am-menu-item" id="nav_profile">My Profile</a>
                  <a href="/mcp" class="am-menu-item" id="nav_mcp">MCP connections</a>
                  <a href="/account" class="am-menu-item" id="nav_account_settings" v-show="get(user, 'permissions.manageAccount', false)">Account Settings</a>
                  <a href="/users" class="am-menu-item" id="nav_users_settings" v-show="get(user, 'permissions.manageUsers', false)">Users</a>
                  <a href="/billing" class="am-menu-item" id="nav_billing" v-show="get(user, 'permissions.manageBilling', false)">Billing</a>
                  <a href="/knowledge-base" class="am-menu-item">Knowledge Base</a>

                  <div class="am-menu-divider" v-show="shouldShowDivider"></div>
                  <a href="/captains-deck" class="am-menu-item" v-show="shouldShowCaptainsDeck">Captains Deck</a>
                  <a href="/captains-deck/health" class="am-menu-item" v-show="shouldShowCaptainsDeck">Account Health</a>
                  <a class="am-menu-item" v-if="$A.AdminImpersonating !== null" @click.prevent="$A.GoBackToAdminAccount()" href="#">Back To Admin User</a>
                  <div class="am-menu-divider"></div>
                  <a class="am-menu-item am-menu-item-danger" @click.prevent="LogOut()" href="#">Log Out</a>
                </div>
              </div>

            </div>
          </div>
        </div>
      </nav>
      <!--    <b-alert variant="warning" id="account-alert" class="nav-alert" :show="alertMessage.length>0" dismissible><span v-html="alertMessage"></span></b-alert>-->

      <b-alert :show="true" v-for="banner in get(curAccount, 'banners', [])" v-bind:key="banner.text" class="nav-alert"
        :variant="banner.vueAlertVariant" :class="banner.cssClass" dismissible v-if="!isFreeUser">
        <span v-html="banner.text"></span>
        <a :href="banner.uri" class="banner-nav-link">{{
          banner.callToAction
        }}</a>
      </b-alert>

      <b-alert :variant="alertType" id="nav-alert" class="nav-alert" :show="alertMessage.length > 0" dismissible><span
          v-html="alertMessage"></span></b-alert>
    </div>
    <StarterPromoCard />
    <GoogleReviewPromoCard />
  </div>
</template>

<style>
.banner-nav-link {
  font-weight: bold;
  color: white;
  padding-left: 5px;
}

.active {
  font-weight: bold;
}

.container-navigation {
  max-width: 100%;
  padding: 0 24px 0 14px;

  @media screen and (max-width: 992px) {
    &.premium-gated {
      max-height: 100vh;
      overflow-y: auto;
    }
  }
}

.fixed-navbar {
  position: fixed;
  min-height: 0;
  margin-bottom: 0;
  top: 0;
  width: 100%;
  z-index: 1030;

  &.premium-gated {
    z-index: 20003;
  }
}

.profile-name {
  font-family: 'Open Sans';
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #1B1B1C;
}

.nav-alert {
  z-index: 999;
  position: relative;
  text-align: center;
}

.alert-trial {
  background: #019255;
  color: #ffffff;
  border-color: none;
  position: fixed;
  margin: 0 0 0 0;
  width: 100%;
  bottom: 0;
}

.alert-trial a {
  color: #ffffff;
}

.alert-trial a:visited {
  color: #ffffff;
}

.nav-gray-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 12px !important;
  height: 38px;
  background: #DEE3EC;
  box-shadow: 0px 1px 2px rgba(8, 11, 13, 0.05);
  border-radius: 6px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #444444;
}

.nav-gray-btn:hover {
  background-color: lightgray;
  border: lightgray solid 1px;
  opacity: 0.8;
}

.nav-item-border:hover {
  opacity: 0.8;
}

.top-50 {
  top: 50px !important;
}


@media (max-width: 991px) {
  .fixed-navbar {
    position: relative;
    z-index: 1050;
  }
}

@media screen and (max-width: 992px) {

  .navbar-nav {
    display: flex;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
    background-color: white;
    align-items: center !important;
    padding-top: 10px !important;
  }

  .proof-timeline-sidebar[data-v-7233b33a] {
    margin-top: 10px;
  }

  .dropdown-menu {
    border: none !important;
    /*border-bottom: 1px solid rgba(0, 0, 0, 0.15) !important;*/
    box-shadow: none !important;
  }

  .dropdown-divider {
    border: 0px !important;
  }

  .account-nav {
    border-bottom: 0.4px solid lightgray !important;
  }

  .ashore-nav {
    background: #ffffff !important;
    border-top: 5px solid #019255 !important;
    display: flex !important;
    flex-direction: row !important;
    justify-content: space-between !important;
    align-items: center !important;
    padding: 0px !important;
    background: white !important;
  }

  .navbar-toggler {
    margin: 10px !important;
  }
}
</style>

<style scoped>
/* Modern nav redesign — refined minimal, brand-green accent */
@media (min-width: 992px) {
  .am-navbar-collapse {
    display: flex !important;
    align-items: center;
    gap: 24px;
  }
}

.am-nav-list {
  display: flex;
  align-items: center;
  gap: 2px;
  list-style: none;
  padding: 0;
  margin: 0;
}

.am-nav-item {
  position: relative;
  display: flex;
  align-items: center;
}

.am-nav-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 8px;
  font-family: 'Open Sans', system-ui, -apple-system, sans-serif;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.005em;
  color: #4b5563;
  text-decoration: none;
  background: transparent;
  transition: background-color 120ms ease, color 120ms ease;
  cursor: pointer;
  white-space: nowrap;
  line-height: 1;
  height: 36px;
}
.am-nav-link:hover {
  background: #f3f4f6;
  color: #111827;
  text-decoration: none;
}
.am-nav-link.is-active {
  color: #019256;
  background: rgba(1, 146, 86, 0.08);
  font-weight: 600;
}
.am-nav-link.is-active:hover {
  background: rgba(1, 146, 86, 0.12);
}

.am-chevron {
  transition: transform 160ms ease;
  opacity: 0.65;
}
.am-dropdown.show .am-chevron,
.am-dropdown[aria-expanded="true"] .am-chevron,
.am-nav-link[aria-expanded="true"] .am-chevron,
.am-profile-trigger[aria-expanded="true"] .am-chevron {
  transform: rotate(180deg);
}

.am-dropdown-toggle::after,
.am-profile-trigger.dropdown-toggle::after {
  display: none !important;
}

.am-nav-link:focus,
.am-nav-link:focus-visible,
.am-profile-trigger:focus,
.am-profile-trigger:focus-visible,
.am-create-btn:focus,
.am-create-btn:focus-visible {
  outline: none;
  box-shadow: none;
}

.am-menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  min-width: 220px;
  padding: 6px;
  background: #ffffff;
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 10px;
  box-shadow:
    0 1px 2px rgba(15, 23, 42, 0.04),
    0 8px 24px rgba(15, 23, 42, 0.08);
  z-index: 1050;
  display: none;
}
.am-menu.show {
  display: block;
}
.am-menu-right {
  left: auto;
  right: 0;
}

.am-menu-item {
  display: block;
  padding: 8px 12px;
  border-radius: 6px;
  font-family: 'Open Sans', system-ui, -apple-system, sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  text-decoration: none;
  background: transparent;
  transition: background-color 100ms ease, color 100ms ease;
  cursor: pointer;
  line-height: 1.3;
}
.am-menu-item:hover {
  background: #f3f4f6;
  color: #111827;
  text-decoration: none;
}
.am-menu-item.is-active {
  color: #019256;
  background: rgba(1, 146, 86, 0.08);
  font-weight: 600;
}
.am-menu-item-danger {
  color: #b91c1c;
}
.am-menu-item-danger:hover {
  background: rgba(185, 28, 28, 0.06);
  color: #991b1b;
}
.am-menu-divider {
  height: 1px;
  margin: 6px 4px;
  background: rgba(15, 23, 42, 0.08);
}

.am-nav-right {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: auto;
}

.am-create-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  border-radius: 8px;
  background: #019256;
  color: #ffffff !important;
  font-family: 'Open Sans', system-ui, -apple-system, sans-serif;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -0.005em;
  text-decoration: none;
  border: 0;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(1, 146, 86, 0.18);
  transition: background-color 120ms ease, box-shadow 120ms ease, transform 120ms ease;
}
.am-create-btn:hover {
  background: #017a48;
  box-shadow: 0 2px 6px rgba(1, 146, 86, 0.24);
  text-decoration: none;
  color: #ffffff !important;
}
.am-create-btn:active {
  transform: translateY(1px);
}

.am-profile-trigger {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 4px 10px 4px 4px;
  border-radius: 999px;
  background: transparent;
  color: #374151;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 120ms ease;
}
.am-profile-trigger:hover {
  background: #f3f4f6;
  text-decoration: none;
  color: #111827;
}
.am-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 999px;
  background-color: #019256;
  background-size: cover;
  background-position: center;
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  flex-shrink: 0;
}
.am-profile-name {
  font-family: 'Open Sans', system-ui, -apple-system, sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: inherit;
  max-width: 160px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-width: 991px) {
  .am-navbar-collapse {
    flex-direction: column;
    align-items: stretch;
    gap: 4px;
    padding: 0 16px 16px;
    background: #ffffff;
    border-top: 1px solid #f1f3f5;
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
  }
  .am-nav-list {
    flex-direction: column;
    align-items: stretch;
    gap: 2px;
    width: 100%;
  }
  .am-nav-item {
    width: 100%;
    flex-direction: column;
    align-items: stretch;
  }
  .am-nav-link {
    width: 100%;
    height: 44px;
    padding: 0 14px;
    justify-content: space-between;
    border-radius: 8px;
  }
  .am-nav-link.is-active {
    background: rgba(1, 146, 86, 0.1);
  }

  /* More dropdown becomes an inline accordion on mobile */
  .am-dropdown.dropdown .am-menu {
    position: static !important;
    display: none;
    box-shadow: none;
    border: 0;
    background: transparent;
    padding: 4px 0 4px 16px;
    margin: 0 !important;
    min-width: 0;
    width: 100%;
    transform: none !important;
    inset: auto !important;
    top: auto !important;
    left: auto !important;
    right: auto !important;
  }
  .am-dropdown.dropdown.show .am-menu,
  .am-dropdown.dropdown .am-menu.show {
    display: block;
  }
  .am-menu-item {
    padding: 12px 14px;
    border-radius: 8px;
  }

  .am-nav-right {
    margin-left: 0;
    margin-top: 8px;
    padding-top: 12px;
    border-top: 1px solid #f1f3f5;
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }
  .am-create-btn {
    justify-content: center;
    height: 44px;
    width: 100%;
    order: 1;
  }
  .am-profile {
    order: 2;
    width: 100%;
  }
  .am-profile-trigger {
    width: 100%;
    height: 44px;
    padding: 4px 14px 4px 6px;
    justify-content: flex-start;
    gap: 12px;
    border-radius: 8px;
  }
  .am-profile-name {
    flex: 1;
    max-width: none;
  }
  .am-profile .am-menu {
    margin-top: 4px;
  }

  /* Hide the loading spinner on mobile — it lives quietly elsewhere */
  .loading_data_spinner {
    align-self: center;
  }
}
</style>
